module.exports = __webpack_public_path__ + "img/block5.a32cff8f.webp";